import { DefaultLayout } from '@/shared/ui/DefaultLayout'

export function SolutionCasesPage() {
  return (
    <DefaultLayout mobileTitle="해결 사례" className="m-0 block bg-white-50">
      <div className="layout-body flex flex-col gap-4 p-4">
        <p className="m-0 rounded-lg bg-white-200 px-4 py-3.5 text-label text-black-500">
          아직 <b>집계 전인 항목</b>입니다. 0건이라는 뜻이 아니라, 세어 둔 값이 아직
          없다는 뜻입니다.
        </p>
      </div>
    </DefaultLayout>
  )
}
